import { useContext } from "react";

import { AccountSettingsContext } from "../contexts";

export function useAccountSettings() {
  return useContext(AccountSettingsContext);
}
